import { isTerminalPipelineRunStatus } from '../constants/pipelineRunStatus';

// pipelines-list-sort-and-narrow AC-17/AC-18 — the list poller's gate.
//
// ⚠ THIS REVERSES A SHIPPED AC, ON PURPOSE, WITH SIGN-OFF. deploy-pipelines-list-payload AC-12
// gated the 4s refetch on the VISIBLE rows, and said so deliberately. That made the poller
// FILTER-BLIND: typing a search term while a run was building elsewhere in the list STOPPED the
// poll, so the run never visibly advanced. It was already a live latent bug with only a search box
// on the page, and every facet this slice adds would have widened it.
//
// The gate now reads the LOADED row set instead. ✅ Signed off by ducp on 2026-08-05 (spec D2), and
// the shipped AC-12 carries a superseded-by annotation at its own end so a future reader does not
// "fix" this back in good faith.
//
// WHAT DID NOT CHANGE — and must not, because it is the other half of the shipped AC:
//   * the STOP condition (AC-18): all-terminal or all-never-run still stops the poll. Only the
//     gate's INPUT SET widened; its logic did not loosen.
//   * one refetch per tick, list-level, never per row (AC-6/AC-21 — the one-round-trip rule).
//   * the poll stays SILENT (AC-20): `loading={false}` remains wired, so a background refetch
//     never pulses the grid's loading overlay.
//
// Extracted as a pure predicate over a row set precisely so AC-17/AC-18 are unit-testable without
// the grid, a router, or a react-query harness — none of which this repo can drive in jsdom.

// A null/undefined LatestRunStatus is NEVER-RUN, not "in flight". A never-run row will not change
// on its own — nothing is building — so it must not hold the poll open. Getting this backwards
// would poll every 4 seconds forever on a list where nothing has ever been run.
export const hasNonTerminalPipelineRun = (rows = []) => (rows ?? []).some(row => row?.LatestRunStatus != null && !isTerminalPipelineRunStatus(row.LatestRunStatus));

export default hasNonTerminalPipelineRun;
